<section class="sz2020" *ngIf="sz2020Logo$ | async">
  <img
    [src]="'/assets/images/sz2020-hu.svg' | ssrEmptyString"
    [alt]="'label.szechenyi-2020-logo' | translate"
    [class.isStatic]="isStatic"
    corporateImageLazyLoad
  />
</section>
